import * as types from "../actionTypes";

export const get = (separation_type, pageNumber = null) => {
  return {
    type: types.PETTY_CASHIER_GET_OVERALL_COST_REQUEST,
    separation_type: separation_type,
    pageNumber
  };
};

export const getSuccess = data => {
  return {
    type: types.PETTY_CASHIER_GET_OVERALL_COST_SUCCESS,
    payLoad: data
  };
};
export const getFailure = error => {
  return {
    type: types.PETTY_CASHIER_GET_OVERALL_COST_FAILURE,
    error
  };
};
